import { apis } from 'ui-common'

export default {
  getMedications: () => apis.$get('/medications')
}
